
import React from "react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { MoreHorizontal, Archive, MessageSquare, Sparkles, ArchiveRestore, Star, Flag } from "lucide-react";

interface ConversationActionsProps {
  conversationId: string;
  currentStatus: 'open' | 'closed' | 'archived';
}

export const ConversationActions = ({ conversationId, currentStatus }: ConversationActionsProps) => {
  const handleStatusChange = async (newStatus: 'open' | 'closed' | 'archived') => {
    try {
      console.log('Status change requested:', { conversationId, newStatus });
      // TODO: Implement actual status update when backend is ready
    } catch (error) {
      console.error("Failed to update conversation status:", error);
    }
  };

  const handleGenerateSummary = () => {
    console.log('Generate summary requested for:', conversationId);
    // TODO: Implement summary generation when backend is ready
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="h-8 w-8 p-0 hover:bg-gray-100">
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {/* AI Actions */}
        <DropdownMenuItem onClick={handleGenerateSummary}>
          <Sparkles className="mr-2 h-4 w-4" />
          Generate Summary
        </DropdownMenuItem>
        
        <DropdownMenuSeparator />
        
        {/* Status Actions */}
        {currentStatus === 'archived' ? (
          <DropdownMenuItem onClick={() => handleStatusChange('open')}>
            <ArchiveRestore className="mr-2 h-4 w-4" />
            Unarchive
          </DropdownMenuItem>
        ) : (
          <DropdownMenuItem onClick={() => handleStatusChange('archived')}>
            <Archive className="mr-2 h-4 w-4" />
            Archive
          </DropdownMenuItem>
        )}
        
        {currentStatus === 'closed' ? (
          <DropdownMenuItem onClick={() => handleStatusChange('open')}>
            <MessageSquare className="mr-2 h-4 w-4" />
            Reopen
          </DropdownMenuItem>
        ) : currentStatus === 'open' && (
          <DropdownMenuItem onClick={() => handleStatusChange('closed')}>
            <MessageSquare className="mr-2 h-4 w-4" />
            Close
          </DropdownMenuItem>
        )}
        
        <DropdownMenuSeparator />
        
        {/* Additional Actions */}
        <DropdownMenuItem>
          <Star className="mr-2 h-4 w-4" />
          Mark Important
        </DropdownMenuItem>
        
        <DropdownMenuItem>
          <Flag className="mr-2 h-4 w-4" />
          Flag for Follow-up
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
